<template>
  <div>
    <Collapse v-model="value">
      <Panel name="1" v-for="(item, index) in workData" :key="index">
      {{ item.carNo }}规划作业线路
        <template #content>
          <ly-form-item label="线路名称">{{ item.lineName }}</ly-form-item>
          <ly-form-item label="开始点">{{ item.startP }}</ly-form-item>
          <ly-form-item label="结束点">{{ item.endP }}</ly-form-item>
          <ly-form-item label="负责人">{{ item.manager==null?'未填写':item.manager }}</ly-form-item>
          <ly-form-item label="联系电话">{{ item.tel==null?'未填写':item.tel }}</ly-form-item>
          <ly-form-item label="线路长度">{{ item.length }}米</ly-form-item>
          
        </template>
      </Panel>
    </Collapse>
  </div>
</template>
<script>
export default {
  props: ["workData"],
  data() {
    return {
      value: "1",
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/locus/works.vue